import type { LegScheduleUpdate } from '../types/scheduling';

/** Resolve a single copy decision before applying the payload to all target PROs. */
export async function schedulingFillUpdate(
  field: string,
  value: string,
  sourceNote: string | undefined,
  confirmCopy: (note: string) => Promise<boolean>,
): Promise<LegScheduleUpdate> {
  if (field === 'scheduling_note') return { scheduling_note: value.trim() };
  const update: LegScheduleUpdate = { [field]: value };
  const note = sourceNote?.trim();
  if (field === 'proposed_appt_date' && note && await confirmCopy(note)) {
    update.scheduling_note = note;
  }
  return update;
}
